// extracted by mini-css-extract-plugin
export var button = "stlyes-module--button--690e3";
export var disabled = "stlyes-module--disabled--a2ddd";
export var loading = "stlyes-module--loading--04b2f";